import { render, staticRenderFns } from "./DoctorRecentCall.vue?vue&type=template&id=b0e04c2c&scoped=true&"
import script from "./DoctorRecentCall.vue?vue&type=script&lang=js&"
export * from "./DoctorRecentCall.vue?vue&type=script&lang=js&"
import style0 from "./DoctorRecentCall.vue?vue&type=style&index=0&id=b0e04c2c&prod&lang=scss&"
import style1 from "./DoctorRecentCall.vue?vue&type=style&index=1&id=b0e04c2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e04c2c",
  null
  
)

export default component.exports